export const data_base = {

    // Lähtötilanne: seisotaan portaiden alapäässä
    scene: '03_stairs_up',
    kysymysteksti: 'Portaat ylöspäin ja nivelrikko vasemmassa lonkassa - mikä siirtyy ensin?',
    maxp: 1,
    optiot: [
        {
            id: 1,
            teksti: 'A oikea jalka',
            valinta: 'A',
            ohjaajan_palaute: 'Joo, just näin - vain sillä pystyy ponnistamaan',
            koontiteksti: '',
            // pisteet: 1,
            // arviointitiedosto: 'scene_03_stairs_up_ok',

        },


        {

            id: 2,
            teksti: 'B vasen jalka',
            valinta: 'B',
            ohjaajan_palaute: 'Oi joi - voiko sillä ponnistaa kun se on kipeä?',
            koontiteksti: '',
            // pisteet: 0,
            // arviointitiedosto: 'scene_03_stairs_up_ei_ok',


        },
        {

            id: 3,
            teksti: 'C molemmat sauvat',
            valinta: 'C',
            ohjaajan_palaute: 'Ei kai noin?',
            koontiteksti: '',
            // pisteet: 0,
            // arviointitiedosto: 'scene_03_stairs_up_ei_ok',


        },
        {

            id: 4,
            teksti: 'D molemmat jalat',
            valinta: 'D',
            ohjaajan_palaute: 'Kauheeta..',
            koontiteksti: '',
            // pisteet: 0,
            // arviointitiedosto: 'scene_03_stairs_up_ei_ok',


        }
    ]


};

export const data_A = {

    //Lähtötilanne: Oikea jalka siirretty yläaskelmalle
    scene: '03_stairs_up',
    kysymysteksti: 'Siirretty oikea jalka ylemmälle askelmalle - mitä seuraavaksi?',
    maxp: 1,
    optiot: [
        {
            id: 1,
            teksti: 'A ponnistus oikealla, vas jalka ja sauvat yhtä aikaa oikean viereen',
            valinta: 'AA',
            ohjaajan_palaute: '',
            koontiteksti: '',
            // pisteet: 1,
            // arviointitiedosto: 'scene_03_stairs_up_ok',

        },


        {

            id: 2,
            teksti: 'B palauta oikea jalka takaisin',
            valinta: 'AB',
            ohjaajan_palaute: '',
            koontiteksti: '',
            // pisteet: 0,
            // arviointitiedosto: 'scene_03_stairs_up_ei_ok',


        },
        {

            id: 3,
            teksti: 'C vasen jalka, sitten sauvat',
            valinta: 'AC',
            ohjaajan_palaute: '',
            koontiteksti: '',
            // pisteet: 0,
            // arviointitiedosto: 'scene_03_stairs_up_ei_ok',


        },
        {

            id: 4,
            teksti: 'D sauvat ensin, sitten ponnista oikealla',
            valinta: 'AD',
            ohjaajan_palaute: '',
            koontiteksti: '',
            // pisteet: 0,
            // arviointitiedosto: 'scene_03_stairs_up_ei_ok',


        }
    ]

};

export const data_B = {

    // Lähtötilanne: vasen jalka siirretty yläaskelmalle
    scene: '03_stairs_up',
    kysymysteksti: 'Siirretty vasen jalka ylemmälle askelmalle - mitä seuraavaksi?',
    maxp: 1,
    optiot: [
        {
            id: 1,
            teksti: 'A palauta vasen jalka takaisin',
            valinta: 'BA',
            ohjaajan_palaute: '',
            koontiteksti: '',
        },





        {

            id: 2,
            teksti: 'B ponnista vasemmalla jalalla, tuo oikea jalka ja sauvat samalle askelmalle',
            valinta: 'BB',
            ohjaajan_palaute: '',
            koontiteksti: '',


        }
    ]


};

export const data_C = {

    // Lähtötilanne: molemmat sauvat siirretty yläaskelmalle
    scene: '03_stairs_up',
    kysymysteksti: 'Nyt molemmat sauvat siirretty ylemmälle askelmalle - mitäs seuraavaksi?',
    maxp: 1,
    optiot: [
        {
            id: 1,
            teksti: 'A palauta sauvat takaisin',
            valinta: 'CA',
            ohjaajan_palaute: '',
            koontiteksti: '',
        },

        {

            id: 2,
            teksti: 'B astu oikealla jalalla sauvojen väliin',
            valinta: 'CB',
            ohjaajan_palaute: '',
            koontiteksti: '',


        }
    ]


};